export default __webpack_public_path__ + "static/media/gif.271adcaa.svg";